module.exports = __webpack_public_path__ + "static/media/infoIcon.2d63e7d9.svg";